/* Development Environment Configuration */

module.exports = {
  ENV_NAME: 'development',
  APP_TEST_MODE: true,  // Set to true to disable SMS, emails, etc. in development
  API_URL: 'https://staging.uniservice.in/api',
  ADMIN_CORNER_URL: ' https://staging.admin.integrafms.com/admin',
  FM_SPACES_BASE_URL: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  STATIC_FILES_DIR: 'https://gointegra-fm-space.blr1.digitaloceanspaces.com/',
  ASSET_FILES_DIR: '/src/asset/'
}



// WEBPACK FOOTER //
// ./src/config/env.dev.js